import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class HeaderLogo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { logo, url },
        } = this.props;

        return (
            <div className={styles.headerlogo}>
                <a href={url} target="_blank" className={styles.position} rel="noreferrer">
                    <img
                        src="https://x0.ifengimg.com/feprod/c/feprod/c/ifengimcp/pic/20210108/3677f2773fd79f12b079_size1_w56_h34.png"
                        className={styles.adTips}
                    />
                    <img src={logo} />
                </a>
            </div>
        );
    }
}

export default errorBoundary(HeaderLogo);
